import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from '../../app.constants';
import { LocalStorageService } from 'ng2-webstorage';

@Injectable()
export class StudentDataService {
  private token: string;
  private schoolId: string;
  constructor(private appConstants: AppConstants, private _http: HttpClient,private localStorage: LocalStorageService) {
    this.token = this.localStorage.retrieve('Token');
    this.schoolId = this.localStorage.retrieve('SchoolId');
  }

  getChildData(childId: string) {
    let parentId = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')

    return this._http.get(`${this.appConstants.baseUrl}GetStudentDetailsParentByChildId?parentid=${parentId}&childid=${childId}`)
  }
  getHieduChildData(childId: string) {


   //return this._http.get(`${this.appConstants.baseUrl}/GetHieduStudentDetailsByChildId?token=${this.token }&schoolid=${this.schoolId}&childid=${childId}&nuofRows=10&pageNumber=1`)

   return this._http.get(`${this.appConstants.baseUrl}/GetHieduStudentDetailsByChildId?token=AE1E2C63-91E2-4F7E-9243-00046643BE78&schoolid=1&childid=6455&nuofRows=10&pageNumber=1`)
  }

   HieduStudentDelete (childId:String){
  //   // let Batchid = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')
  //   // let schoolId = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')

   return this._http.delete(`${this.appConstants.baseUrl}DeleteHiEduStudentByChildId?childid=${childId}`)
   }


   updateHiChildInfo (childId:String){
    //   // let Batchid = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')
    //   // let schoolId = localStorage.getItem('ng2-webstorage|parentportalparentid').replace(/['"]+/g, '')

     return this._http.delete(`${this.appConstants.baseUrl}UpdateHieduStudentInfo?childid=${childId}`)
     }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/service/student-data.service.ts